module.exports = __webpack_public_path__ + "static/pie_painter_5-b49bcd50e91cc0ec6156045448ac078e.png";